module.exports = __webpack_public_path__ + "img/munzinger-chronik.300eaad7.png";